import React, { ChangeEvent} from 'react';
import {DeleteIcon, EditIcon, XIcon} from 'assests/GmsIcons';
import {EXCLUSION_DEFAULT, EXCLUSION_OPTIONS} from "../../../ISRConstants";
import OverlayIcon from "../../../../../../Components/GMS/Rules/Components/OverlayIcon";
import ToggleButton from "../../../../../../Components/Common/components/Inputs/ToggleButton";
import imageUploadPlaceholder from '../../../../../../assests/img/sb3_image_upload_placeholder_small.png';
import { toast } from 'Components/DesignSystem/Toast/useToast';

const EditCategory = ({category, submodel, categoryIndex, modelIndex, updateCategory, setCategoryEditFlag, setEditCategoryImage, setShowAttributeModal, attributes, loadingAttributes}: any) => {

    const handleProductLabelChange = (event: ChangeEvent<HTMLSelectElement>) => {
        const labelValue = event.target.value;
        updateCategory({...category, productLabel: labelValue}, categoryIndex, modelIndex);
    }

    const handleChangeGroupLabel = (value: string) => {
        updateCategory({...category, groupLabel: value}, categoryIndex, modelIndex);
    }

    const handleChangeCategorySelectionLabel = (value: string) => {
        updateCategory({...category, categorySelectionLabel: value}, categoryIndex, modelIndex);
    }

    const handleExclusionChange = (event: ChangeEvent<HTMLSelectElement>) => {
        const categoryExclusion = event.target.value;
        updateCategory({...category, exclusion: categoryExclusion}, categoryIndex, modelIndex);
    }

    const handleHideWhenNoProductsAvailableChange = (value: boolean) => {
        updateCategory({...category, hideWhenNoProductsAvailable: value}, categoryIndex, modelIndex);
    };

    const handleInclusionChange = (event: ChangeEvent<HTMLSelectElement>) => {
        const categoryInclusion = event.target.value;
        updateCategory({...category, inclusion: categoryInclusion}, categoryIndex, modelIndex);
    }

    const handleFieldImageDisplayChange = (event: ChangeEvent<HTMLSelectElement>) => {
        const imageDisplay = event.target.value;
        updateCategory({...category, imageDisplay: imageDisplay}, categoryIndex, modelIndex);
    }

    const removeThumbnailImageChange = () => {
        updateCategory({...category, thumbnail: null}, categoryIndex, modelIndex);
    }

    const handleDefaultSortChange = (event: ChangeEvent<HTMLSelectElement>) => {
        updateCategory({...category, sortConfig: {...sortConfig, selectedDefaultSortId: event.target.value}}, categoryIndex, modelIndex);
    }

    const handleDelete = (id: string) => {
        const sortableAttributes = sortConfig.sortableAttributes ?? [];
        const selectedDefaultSortId = sortConfig.selectedDefaultSortId.includes(id) ? 'compatioscore_descending' : sortConfig.selectedDefaultSortId;
        updateCategory({...category, sortConfig: {...sortConfig, sortableAttributes: sortableAttributes.filter((attr: any) => attr.id !== id)}, selectedDefaultSortId: selectedDefaultSortId}, categoryIndex, modelIndex);
        setShowAttributeModal(false);
    };

    const productLabels = ["Add to cart", "Guide", "Add to build"]
    const categorySelectionLabel = category?.categorySelectionLabel ?? '';
    const sortConfig = category?.sortConfig ?? {
        defaultSortOptions: [
            {id: 'compatioscore_descending', label: 'Recommended', direction: 'desc'},
            {id: 'price_ascending', label: 'Price (Low to High)', field: 'product_price', direction: 'asc'},
            {id: 'price_descending', label: 'Price (High to Low)', field: 'product_price', direction: 'desc'},
            {id: 'alphabetical_ascending', label: 'Alphabetical (A to Z)', field: 'product_title', direction: 'asc'},
            {id: 'alphabetical_descending', label: 'Alphabetical (Z to A)', field: 'product_title', direction: 'desc'},
        ],
        sortableAttributes: [],
        selectedDefaultSortId: 'compatioscore_descending',
    };
    const transformedAttributes = sortConfig.sortableAttributes.flatMap((attr: any) => [
        {...attr, id: `${attr.id}_asc`, label: `${attr.label || attr.name} ${attr.dataType === "TEXT" ? '(A to Z)' : attr.dataType === "BOOLEAN" ? '(False-True)' : '(Low to High)'}`},
        {...attr, id: `${attr.id}_desc`, label: `${attr.label || attr.name} ${attr.dataType === "TEXT" ? '(Z to A)' : attr.dataType === "BOOLEAN" ? '(True-False)' : '(High to Low)'}`},
    ]);
    return(
        <div className="tw-w-[375px] tw-absolute tw-h-full tw-overflow-y-scroll tw-bg-white tw-shadow tw-float-right tw-right-0 tw-top-0" style={{zIndex: 1000}}>
            <div className="tw-text-sky-950 tw-text-sm tw-font-semibold tw-font-['Noto Sans'] tw-leading-tight tw-my-[18px] tw-mx-[12px]">{category?.categoryName}</div>
            <button aria-label="Close" data-testid="components-editcategory-button-1" className="tw-text-black tw-float-right tw-my-[-36px] tw-mx-[24px]" onClick={()=>setCategoryEditFlag(false)}>
                <XIcon />
            </button>
            <div className="tw-w-[373px] tw-h-[0px] tw-border tw-border-zinc-300"></div>

            <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-mt-[18px] tw-mb-2 tw-mx-[12px]">Exclusions</div>
            <select data-testid="components-editcategory-select-2" className="drop-down-dm tw-w-[180px] tw-py-2 tw-mx-[12px] tw-h-[36px] tw-w-[335px]" value={category?.exclusion ?? EXCLUSION_DEFAULT} onChange={handleExclusionChange} >
                {EXCLUSION_OPTIONS.map((item, index) => {
                    return (
                        <option value={item} key={item + index}>
                        {item}
                    </option>);
                })}
            </select>
            {/*<div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-mt-[18px] tw-mb-2 tw-mx-[12px]">Inclusions</div>*/}
            {/*<select className="drop-down-dm tw-w-[180px] tw-py-2 tw-mx-[12px] tw-h-[36px] tw-w-[335px]" value={uiCategory?.inclusion ?? INCLUSION_DEFAULT} onChange={handleInclusionChange} >*/}
            {/*    {INCLUSION_OPTIONS.map((item, index) => {*/}
            {/*        return (*/}
            {/*            <option value={item} key={item + index}>*/}
            {/*            {item}*/}
            {/*        </option>);*/}
            {/*    })}*/}
            {/*</select>*/}

            <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-mt-[18px] tw-mb-2 tw-mx-[12px]">Product Label</div>
            <select data-testid="components-editcategory-select-3" className="drop-down-dm tw-w-[180px] tw-py-1 tw-mx-[12px] tw-h-[36px] tw-w-[335px]" value={category?.productLabel ?? 'Add to cart'} onChange={handleProductLabelChange} >
                {productLabels && productLabels.map((item, index) => {
                    return (
                        <option value={item} key={item + index}>
                        {item}
                    </option>);
                })}
            </select>
            <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-mt-[18px] tw-mb-2 tw-mx-[12px]">Group Label</div>
            <input data-testid="components-editcategory-input-4" className="tw-rounded tw-bg-shades-of-grey-0 tw-box-border tw-w-[335px] tw-h-9 tw-flex tw-flex-row tw-items-center tw-justify-start tw-mt-1 tw-px-2.5 tw-gap-[2px] tw-text-sm tw-text-shades-of-grey-60 tw-border-[1px] tw-border-solid tw-border-grey-550 focus:tw-outline-none tw-mx-[12px]"
                type='text'
                value={category?.groupLabel}
                onChange={(e) => {
                    handleChangeGroupLabel(e.target.value)
                }}
                placeholder={'Group Label'}
            />
            <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-mt-[18px] tw-mb-2 tw-mx-[12px]">Category Selection Label</div>
            <input data-testid="components-editcategory-input-5" className="tw-rounded tw-bg-shades-of-grey-0 tw-box-border tw-w-[335px] tw-h-9 tw-flex tw-flex-row tw-items-center tw-justify-start tw-px-2.5 tw-gap-[2px] tw-text-sm tw-text-shades-of-grey-60 tw-border-[1px] tw-border-solid tw-border-grey-550 focus:tw-outline-none tw-mx-[12px]"
                type='text'
                value={categorySelectionLabel}
                onChange={(e) => {
                    handleChangeCategorySelectionLabel(e.target.value)
                }}
                maxLength={50}
                placeholder={'Category Selection Label'}
            />
            <label className="tw-text-slate-500 tw-mt-[18px] tw-mb-2 tw-ms-[12px] ">
                {'Hide, when no products are available'}
                <span className="tw-ml-1 tw-inline-block">
                    <OverlayIcon
                        message="When enabled, automatically hides the sections (Page/SubModel/Category) if no compatible products are available"
                        placement="bottom"
                    />
                </span>
            </label>
            <div className="tw-mx-[12px]">
                <ToggleButton
                    name="HideWhenNoProductsAvailable"
                    value={submodel.config.hideWhenNoProductsAvailable === true ? true :category?.hideWhenNoProductsAvailable ?? false}
                    onChange={(e) => submodel.config.hideWhenNoProductsAvailable === true ? null : handleHideWhenNoProductsAvailableChange(e.target.checked)}
                />
            </div>
            <div className='tw-flex tw-flex-1 tw-mr-[18px]'>
                <div className='tw-flex-1 tw-mx-[12px]'>
                    <div className="tw-flex-auto tw-flex tw-mt-[18px] tw-mb-2 tw-items-center">
                    <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-me-[5px]">Thumbnail image</div>
                    </div>
                    <div role="button" data-testid="components-editcategory-div-1" onClick={() => category?.thumbnail ?  removeThumbnailImageChange() : setEditCategoryImage({category: category, categoryIndex: categoryIndex, modelIndex: modelIndex})} className="tw-cursor-pointer tw-flex-auto tw-flex tw-items-center">
                        <img className="tw-w-11 tw-h-11" src={!category?.thumbnail ? imageUploadPlaceholder : category?.thumbnail}  alt={'categoryImage'}/>
                        <div className={`tw-text-[#0747a6] tw-text-sm font-normal tw-leading-tight tw-mx-[6px] ${category?.thumbnail ? 'tw-text-[#bf2600]' : ''}`}>{!category?.thumbnail ? 'Add Image' : 'Remove'}</div>
                    </div>
                </div>
                <div className='tw-flex-1 tw-mx-[12px]'>
                    <div className="tw-flex-auto tw-flex tw-mt-[18px] tw-mb-2 tw-items-center">
                    <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-me-[5px]">Image Display</div>
                    </div>
                    <select data-testid="components-editcategory-select-6" disabled={!category?.thumbnail} id='field-image-display-select' className={`drop-down-dm tw-flex-1 tw-py-1 tw-h-[36px] ${!category?.thumbnail ? 'tw-bg-[#f4f5f7] tw-text-[#969fae]`' : ''}`}
                            value={category?.imageDisplay ?? 'Fit'} onChange={handleFieldImageDisplayChange}>
                        {['Fit', 'Fill'].map((item, index) => {
                            return (
                                <option id={`field-image-display-select-option-${item}`} value={item} key={item + index}>
                                    {item}
                                </option>);
                        })}
                    </select>
                </div>
            </div>
            <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-mt-[18px] tw-mb-1 tw-mx-[12px]">Sort by Attributes</div>
            {sortConfig.sortableAttributes.map((attribute: any, index: any) => (
          <div
            key={index}
            className="tw-mx-[12px] tw-flex tw-items-center tw-justify-between tw-p-2 tw-bg-white tw-border-b tw-border-grey-200"
          >
            <div className="tw-flex tw-items-center tw-flex-1">
              <span className="tw-text-lg tw-font-medium tw-text-gray-900 tw-capitalize">
                {attribute.label || attribute.name}
              </span>
            </div>

            <div className="tw-flex tw-items-center tw-space-x-3">

              <div className="tw-w-px tw-h-6 tw-bg-gray-300"/>

              <span className="tw-text-gray-500 tw-font-medium tw-capitalize">
                {attribute.dataType}
              </span>

              <button data-testid={`components-editcategory-button-7-${index}`}
                onClick={() => {
                    if(loadingAttributes) return;
                    setShowAttributeModal(true);
                }}
                className="tw-p-2 tw-text-red-500 hover:tw-text-red-700 tw-transition-colors"
                aria-label={`Edit ${attribute.name}`}
              >
                <EditIcon/>
              </button>

              <button data-testid={`components-editcategory-button-8-${index}`}
                onClick={() => handleDelete(attribute.id)}
                className="tw-p-2 tw-text-red-500 hover:tw-text-red-700 tw-transition-colors"
                aria-label={`Delete ${attribute.name}`}
              >
                <DeleteIcon/>
              </button>
            </div>
          </div>
        ))}
            <button data-testid="components-editcategory-button-9" disabled={loadingAttributes} onClick={() => {
                if(attributes && attributes.length > 0) {
                   setShowAttributeModal(true);
                } else {
                    toast.error('Category field doesnt have attributes')
                }
            }} className="small-filled-btn tw-px-[24px] tw-h-[30px] tw-mx-[12px] tw-mt-[10px] tw-mb-2">Add Attribute</button>
            <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-mt-[12px] tw-mb-2 tw-mx-[12px]">Default Sort</div>
            <select data-testid="components-editcategory-select-10" className="drop-down-dm tw-w-[180px] tw-py-1 tw-mx-[12px] tw-h-[36px] tw-w-[335px]" value={sortConfig.selectedDefaultSortId} onChange={handleDefaultSortChange} >
                {sortConfig.defaultSortOptions && sortConfig.defaultSortOptions.map((item: any, index: any) => {
                    return (<option value={item.id} key={index}>{item.label ?? ''}</option>);
                })}
                {transformedAttributes && transformedAttributes.map((item: any, index: any) => {
                    return (<option value={item.id} key={index}>{item.label}</option>);
                })}
            </select>
            <button data-testid="components-editcategory-button-11" onClick={() => setCategoryEditFlag(false)} className="small-filled-btn tw-px-[24px] tw-h-[30px] tw-mx-[12px] tw-my-[30px]">Done</button>
        </div>
    );
}

export default EditCategory;